module.exports = __webpack_public_path__ + "img/server-pass.a3f4265f.svg";